import { FaroText, grey, orange } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import { type JSX } from "react";
import { OVAL_RADIUS } from "./calendar-styles";

/** Size of the dot marking a bucket that holds captures, and its inset from the corner */
const DOT_SIZE = "6px";
const DOT_INSET = "4px";

/**
 * @returns How many captures a month or day holds, as a small neutral chip
 * @param props The count to show
 */
export function CaptureCountChip({ count }: { count: number }): JSX.Element {
  return (
    <FaroText
      component="span"
      variant="labelS"
      color={grey[200]}
      data-testid="capture-count"
      sx={{
        minWidth: "18px",
        height: "18px",
        px: 0.5,
        boxSizing: "border-box",
        borderRadius: OVAL_RADIUS,
        backgroundColor: grey[800],
        fontSize: "11px",
        lineHeight: "18px",
        textAlign: "center",
        // Equal-width digits keep the chips' widths steady down the list
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {count}
    </FaroText>
  );
}

/** @returns The orange dot marking a bucket that holds captures, pinned to its top-right */
export function CaptureDot(): JSX.Element {
  return (
    <Box
      component="span"
      data-testid="capture-dot"
      sx={{
        // Both PickerDay and ButtonBase are `position: relative`
        position: "absolute",
        top: DOT_INSET,
        right: DOT_INSET,
        width: DOT_SIZE,
        height: DOT_SIZE,
        borderRadius: "50%",
        backgroundColor: orange[400],
        pointerEvents: "none",
      }}
    />
  );
}
